import { apiGet } from '../../api'

export const delete_greenlight_survey = query => {
  return apiGet({
    endpoint: `greenlight/delete_survey?${query}`
  })
}
